module.exports = __webpack_public_path__ + "img/external-link.d0839a73.svg";